var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66661 7.99999C6.66661 7.26361 7.26356 6.66666 7.99994 6.66666C8.73632 6.66666 9.33327 7.26361 9.33327 7.99999C9.33327 8.73637 8.73632 9.33332 7.99994 9.33332C7.26356 9.33332 6.66661 8.73637 6.66661 7.99999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 2.66666C6.09216 2.66666 4.53684 3.5098 3.38444 4.47161C2.23361 5.43211 1.44459 6.54285 1.04942 7.16855L1.03337 7.19388C0.954952 7.31731 0.853142 7.47756 0.801675 7.7021C0.760119 7.8834 0.760119 8.11658 0.801675 8.29788C0.853142 8.52242 0.954951 8.68267 1.03336 8.8061L1.04942 8.83143C1.44459 9.45713 2.23361 10.5679 3.38444 11.5284C4.53684 12.4902 6.09216 13.3333 7.99994 13.3333C9.90773 13.3333 11.463 12.4902 12.6154 11.5284C13.7663 10.5679 14.5553 9.45713 14.9505 8.83142L14.9665 8.80611C15.0449 8.68268 15.1467 8.52243 15.1982 8.29788C15.2398 8.11658 15.2398 7.8834 15.1982 7.7021C15.1467 7.47755 15.0449 7.3173 14.9665 7.19387L14.9505 7.16855C14.5553 6.54285 13.7663 5.43211 12.6154 4.47161C11.463 3.5098 9.90772 2.66666 7.99994 2.66666ZM7.99994 5.33332C6.52718 5.33332 5.33327 6.52723 5.33327 7.99999C5.33327 9.47275 6.52718 10.6667 7.99994 10.6667C9.4727 10.6667 10.6666 9.47275 10.6666 7.99999C10.6666 6.52723 9.4727 5.33332 7.99994 5.33332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.81f3d36d1504ad03dc69b0cfb3713d49.svg";
export { ForwardRef as ReactComponent };